import { useEffect } from 'react';

import { MathUtils, Vector3 } from 'three';
import { OrbitControls as OrbitControlsImpl } from 'three-stdlib';

type UsePanBoundsParams = {
    controls: OrbitControlsImpl;
    enablePan: boolean;
    panBoundsCenter?: Vector3;
    maxPanOffset?: number;
};

// Clamp pan target within bounds when panning is enabled
export function usePanBounds({ controls, enablePan, panBoundsCenter, maxPanOffset = 1 }: UsePanBoundsParams) {
    useEffect(() => {
        if (!enablePan || !panBoundsCenter) return;

        const handleChange = () => {
            const offset = controls.target.clone().sub(panBoundsCenter);

            const clampedX = MathUtils.clamp(offset.x, -maxPanOffset, maxPanOffset);
            const clampedY = MathUtils.clamp(offset.y, -maxPanOffset, maxPanOffset);
            const clampedZ = MathUtils.clamp(offset.z, -maxPanOffset, maxPanOffset);

            // Only update if something actually changed
            if (offset.x !== clampedX || offset.y !== clampedY || offset.z !== clampedZ) {
                controls.target.copy(panBoundsCenter.clone().add(new Vector3(clampedX, clampedY, clampedZ)));
            }
        };

        controls.addEventListener('change', handleChange);

        return () => {
            controls.removeEventListener('change', handleChange);
        };
    }, [controls, enablePan, panBoundsCenter, maxPanOffset]);
}
